import { register } from 'swiper/element/bundle'
register()

import Swiper from 'swiper'

export const init = (comp) => {
    return new Promise((resolve) => {
        const mainSwiperEl = comp.querySelector('.swiper-history-main');
        const verticalSwiperEl = comp.querySelector('.swiper-history-vertical');
        const verticalSwiperSwipes = verticalSwiperEl.querySelectorAll('.swiper-slide');

        mainSwiperEl.addEventListener('swiperslidechange', (event) => {
            verticalSwiperSwipes.forEach(element => {
                element.classList.remove('active');
            });

            verticalSwiperSwipes[mainSwiperEl.swiper.activeIndex].classList.add('active');
        });

        if (verticalSwiperEl) {
            new Swiper(verticalSwiperEl, {
                loop: false,
                grabCursor: true,
                spaceBetween: 0,
                slidesPerView: 'auto',
                direction: 'vertical',
                autoHeight: true,
                on: {
                    init: () => {
                        if (window.innerWidth >= 1024) {
                            verticalSwiperEl.style.height = verticalSwiperEl.closest('.section').querySelector('.swiper-history-main').offsetHeight + 'px';
                        }
                    },
                    click: (swiper, event) => {
                        verticalSwiperEl.swiper.slideTo(event.target.getAttribute('data-index'));
                        mainSwiperEl.swiper.slideTo(event.target.getAttribute('data-index'));
                    },
                    activeIndexChange: (swiper) => {
                        verticalSwiperEl.swiper.slideTo(swiper.activeIndex);
                        mainSwiperEl.swiper.slideTo(swiper.activeIndex);
                    },
                },
            });
        }

        return resolve('Hiistory loaded')
    })
}